import IframeActivity from "./IframeActivity";

export default function FocusChallenge() {
    return (
        <IframeActivity
            src="/activities/focus-challenge/index.html"
            title="Focus Under Pressure"
        />
    );
}